import { message } from "antd";
import { STRIPE_PAYMENT_REFUND } from "../configs/api-paths";
import BaseService from "./base/BaseService";
import { fetchResource } from "../utilities";

/**
 * Service dealing with Payments.
 */
class PaymentService extends BaseService {
	refund = async (quoteId, amount) => {
		const stripeRefundAmount = Math.abs(
			Math.round((amount + Number.EPSILON) * 100)
		);
		const refundRequest = {
			quoteId: quoteId,
			amount: stripeRefundAmount,
			currency: "gbp",
		};

		let hideLoadingMessage = message.loading("Refunding...", 0);

		try {
			await fetchResource(STRIPE_PAYMENT_REFUND, {
				method: "POST",
				body: refundRequest,
			});
			hideLoadingMessage();
			message.success("Successfully issued refund", 5);
			return true;
		} catch (error) {
			hideLoadingMessage();

			message.error(`Failed to issue a refund, please try later or contact administrator`, 5);
			return false;
		}
	};
}

export default PaymentService;
